import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";
import { SplitText } from "gsap/SplitText";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { Observer } from "gsap/Observer";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
    
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

//import Anim8_masthead from './anim/anim8.masthead';
//import Anim8_masthead_generic from './anim/anim8.masthead.generic';
//import Anim8_page_careers from './anim/anim8.page.careers';
import Anim8_news from './anim/anim8.news';
import Anim8_showreel from './anim/anim8.showreel';
import Anim8_pirates from './anim/anim8.pirates';
//import Anim8_disruption from './anim/anim8.disruption';
import Anim8_casestudies from './anim/anim8.casestudies';
//import Anim8_pirates_banner from './anim/anim8.pirates_banner';
import Anim8_announcements from './anim/anim8.announcements';
import Anim8_footer from './anim/anim8.footer';
//import Slash from "../helpers/slash";

(function() {
	'use strict'; 

	// wait until DOM is ready
	document.addEventListener('DOMContentLoaded', function(event){

		console.info('DOM loaded');

		gsap.registerPlugin( 
			ScrollTrigger,
			ScrollSmoother,
			Observer,
			ScrollToPlugin,
			SplitText,
			//MotionPathPlugin,
			DrawSVGPlugin,
			ScrambleTextPlugin,
			TextPlugin,
			MorphSVGPlugin
		);

		ScrollTrigger.normalizeScroll(true);

		/** /
		ScrollSmoother.create({
			smooth: 2,
			effects: true,
			//normalizeScroll: true
		});
		/**/

		/** /
		new Slash({
            elementSelector: "body",
            onAnimateInBegin: () => {
                if (this.bodyClassList.contains('site')) {
                    this.home.freezeVideo();
                }
            },
            onAnimateInEnd: () => {
                if (this.bodyClassList.contains('site')) {
                    this.home.unfreezeVideo();
                }
            },
            onAnimateOutBegin: () => {
                if (this.bodyClassList.contains('site')) {
                    this.home.freezeVideo();
                }
            },
            onAnimateOutEnd: () => {
                if (this.bodyClassList.contains('site')) {
                    this.home.unfreezeVideo();
                }
            }
        });
		/**/

		//wait until images, links, fonts, stylesheets, and js is loaded
 		window.addEventListener('load', function(e){
	
			console.warn('GSAP PLUGINS REGISTERED');

			const sectionPageTitle = document.querySelector('#section-hero.generic');
			const sectionHome = document.querySelector('#section-hero:not(.generic)');
			const sectionHomeDisruption = document.querySelector('.container-testimonal');
			const sectionHomeCaseStudies = document.querySelector('#home-case-studies');
			const sectionHomeNews = document.querySelector('#container-news-homepage');
			const sectionHomeVideo = document.querySelector('#container-showreel-homepage');
			const sectionHomeAnnouncements = document.querySelector('#container-announcements-homepage');
			const sectionHomePirates = document.querySelector('#container-pirates-homepage');
			//const sectionPiratesBanner = document.querySelector('#container-pirates-cta');
			const sectionFooter = document.querySelector('#container-footer');

			if( sectionHome ) {
				//const timeline_01 = new Anim8_masthead(null, null, null, sectionHome);
			}
			if( sectionPageTitle ) {
				//const timeline_00 = new Anim8_masthead_generic(null, null, null, sectionPageTitle);
			}
			if( sectionHomeVideo ) {
				const timeline_02 = new Anim8_showreel(null, null, null, sectionHomeVideo);
			}
			if( sectionHomeAnnouncements ) {
				const timeline_03 = new Anim8_announcements(null, null, null, sectionHomeAnnouncements);
			}
			//
			//if( sectionHomeDisruption ) {
			//	const timeline_04 = new Anim8_disruption(null, null, null, sectionHomeDisruption);
			//}
			const timeline_05 = new Anim8_casestudies(null, null, null, sectionHomeCaseStudies);
			const timeline_06 = new Anim8_pirates(null, null, null, sectionHomePirates);
			//const timeline_07 = new Anim8_pirates_banner(null, null, null, sectionPiratesBanner);
			if( sectionHomeNews ) {
				const timeline_08 = new Anim8_news(null, null, null, sectionHomeNews);
			}
			if( sectionFooter ) {
				const timeline_09 = new Anim8_footer(null, null, null, sectionFooter);
			}

			const sectionCareersPage = document.querySelector('#section-careers-01');
			if( sectionCareersPage ) {
				//new Anim8_page_careers(null, null, null, sectionCareersPage);
			}

			const buttonContactUs = document.body.querySelector('#contact-us-marquee');
			if( buttonContactUs ) {
				buttonContactUs.addEventListener('click', (evt) => {
					evt.preventDefault();
					gsap.to(window, { duration: 2, scrollTo: "#container-footer" });
				});
			}

			const buttonCustomButtons = document.body.querySelectorAll('.custom-call-to-action');
			if( buttonCustomButtons && buttonCustomButtons.length > 0 ) {
				buttonCustomButtons.forEach((customCTA)=>{

					customCTA.addEventListener('click', (evt) => {
						evt.preventDefault();

						const target = evt.currentTarget;

						if( target ) {

							//const link = $(evt.currentTarget);
							const linkHref = target.getAttribute('href');
			
							if( target.classList.contains('external') ) {

								const pageTransition = document.body.querySelector('e-page-transition');
			
								if( pageTransition ) {
									pageTransition.classList.remove('e-page-transition--entered');
									pageTransition.classList.add('e-page-transition--exiting');
								}
			
								const tt = setTimeout(()=>{
									window.location = linkHref;
									clearTimeout(tt);
								}, 750);
			
							} else {
			
								//this.scrollbar.scrollIntoView(document.querySelector(linkHref));
								gsap.to(window, { duration: 2, scrollTo: `${linkHref}` });
							}
			
						}
					});

				})
			}
	
			const buttonsScrollTo = document.body.querySelectorAll('.custom-scrollTo a');
			if( buttonsScrollTo && buttonsScrollTo.length > 0 ) {
				buttonsScrollTo.forEach((buttonScrollTo)=>{

					buttonScrollTo.addEventListener('click', (evt) => {
						evt.preventDefault();

						const target = evt.currentTarget;

						if( target ) {

							//const link = $(evt.currentTarget);
							const linkHref = target.getAttribute('href');
			
							if( target.classList.contains('external') ) {

								const pageTransition = document.body.querySelector('e-page-transition');
			
								if( pageTransition ) {
									pageTransition.classList.remove('e-page-transition--entered');
									pageTransition.classList.add('e-page-transition--exiting');
								}
			
								const tt = setTimeout(()=>{
									window.location = linkHref;
									clearTimeout(tt);
								}, 750);
			
							} else {
			
								//this.scrollbar.scrollIntoView(document.querySelector(linkHref));
								gsap.to(window, { duration: 2, scrollTo: `${linkHref}` });
							}
			
						}
					});

				})
			}

			const menuCustomCrolls = document.body.querySelectorAll('.custom-scrollTo');
			if( menuCustomCrolls && menuCustomCrolls.length > 0 ) {
				menuCustomCrolls.forEach((btnnn) => {
					btnnn.addEventListener('click', (evt) => {

						evt.preventDefault();

						const target = evt.currentTarget;

						//const sectionId = target.getAttribute('href');
						//console.info('custom sroll::', sectionId);

						if( target ) {

							//const link = $(evt.currentTarget);
							const linkHref = target.getAttribute('href');
				
							gsap.to(window, { duration: 2, scrollTo: `${linkHref}` });
				
						}
					});
				});
			}

		}, false);

	});

})();
